var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgServiceLogo = function SvgServiceLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4D77",
    fillRule: "evenodd",
    d: "M4.835 4.715C3.01 5.484 2.12 7.406 2.948 9.37c1.068 2.538 5.77 3.979 5.992 4.01.198.032.43-.083.43-.303s-.43-2.043-.43-2.172.072-.245.197-.297c.124-.051 5.577-2.363 7.385-3.123a3.523 3.523 0 0 0 1.887-4.654C17.63.983 15.573.178 13.755.943s-7.096 3.005-8.92 3.772",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_162_137261)",
    fillRule: "evenodd",
    d: "M17.468 18.595c1.824-.769 2.713-2.691 1.887-4.654-1.07-2.538-5.771-3.97-5.992-4.002-.2-.03-.432.084-.432.304s.432 2.033.432 2.162c0 .13-.073.246-.197.298s-5.578 2.363-7.386 3.123a3.523 3.523 0 0 0-1.887 4.654c.778 1.848 2.836 2.652 4.654 1.887 1.82-.765 7.096-3.006 8.92-3.772",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_162_137261",
    x1: 14.58,
    x2: 14.211,
    y1: 23.441,
    y2: 10.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF4D77",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D77",
    stopOpacity: 0.4
  })))));
};
export default SvgServiceLogo;